import { render, staticRenderFns } from "./UploadAvata.vue?vue&type=template&id=b6f1637a&scoped=true"
import script from "./UploadAvata.vue?vue&type=script&lang=js"
export * from "./UploadAvata.vue?vue&type=script&lang=js"
import style0 from "./UploadAvata.vue?vue&type=style&index=0&id=b6f1637a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f1637a",
  null
  
)

export default component.exports